<template>
  <div>
    <div class="desktop">
      <section class="checker-spec-hero">
        <span>Checker의 기술사양</span>
      </section>
      <section class="specs-detail">
        <div class="spec">
          <div class="checker-spec-title">
            <span>구성</span>
          </div>
          <div style="display:inline-flex; justify-content: space-between; align-items: baseline;" class="checker-spec-description">
            <div class="img-container">
              <img style="width: 255px;" src="@/assets/checker/m-spec-detail-checker.png" alt>
              <p class="name">본체</p>
            </div>
            <div class="img-container linker-mid-img">
              <img style="width: 256px;" src="@/assets/checker/m-spec-detail-magnet.png" alt>
              <p class="name">마그넷</p>
            </div>
          </div>
        </div>
        <div class="spec">
          <div class="checker-spec-title">
            <span>크기 및 무게</span>
          </div>
          <div class="checker-spec-description dimension">
            <div>
              <span style="font-weight: bold;">본체</span>
              <div style="display: block; width: 100%; height: 2px; background-color: #dee2e5; margin-top: 6px; margin-bottom: 25px;"></div>
              <div>
                <span class="dimension-title">크기</span>
                <div class="dimension-description">
                  <p>가로: 7.5cm</p>
                  <p>세로: 4cm</p>
                  <p>두께: 1.6cm</p>
                </div>
              </div>
              <div style="display: block; margin-top: 20px;">
                <span class="dimension-title">무게</span>
                <div class="dimension-description">
                  <p>145g</p>
                </div>
              </div>
            </div>
            <div>
              <span style="font-weight: bold;">마그넷</span>
              <div style="display: block; width: 100%; height: 2px; background-color: #dee2e5; margin-top: 6px; margin-bottom: 25px;"></div>
              <div>
                <span class="dimension-title">크기</span>
                <div class="dimension-description">
                  <p>가로: 7.5cm</p>
                  <p>세로: 1cm</p>
                  <p>두께: 1.6cm</p>
                </div>
              </div>
              <div style="display: block; margin-top: 20px;">
                <span class="dimension-title">무게</span>
                <div class="dimension-description">
                  <p>145g</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="spec">
          <div class="checker-spec-title">
            <span>색상</span>
          </div>
          <div class="checker-spec-description">
            <p>화이트 & 다크 그레이</p>
          </div>
        </div>
        <div class="spec">
          <div class="checker-spec-title">
            <span>지원 운영체제</span>
          </div>
          <div class="checker-spec-description">
            <p>iOS,Android</p>
            <p>*해외 안드로이드폰의 경우 호환이 어려울 수 있습니다.</p>
          </div>
        </div>
        <div class="spec">
          <div class="checker-spec-title">
            <span>연결</span>
          </div>
          <div class="checker-spec-description">
            <p>Wi-Fi</p>
          </div>
        </div>
        <div class="spec">
          <div class="checker-spec-title">
            <span>요구사항</span>
          </div>
          <div class="checker-spec-description">
            <p>Wi-Fi 네트워크 2.4GHz</p>
          </div>
        </div>
        <div class="spec" style="margin-bottom: 90px;">
          <div class="checker-spec-title">
            <span>충전</span>
          </div>
          <div class="checker-spec-description">
            <p>3시간 이면 배터리 완충</p>
            <p>약 100일 사용</p>
          </div>
        </div>
      </section>
    </div>
    <div class="mobile">
      <section class="m-checker-spec-hero">
        <h1>Checker</h1>
        <p>Checker의 기술사양</p>
      </section>
      <section class="m-specs-detail">
        <div class="m-spec">
          <p class="m-spec-title">구성</p>
          <div class="m-spec-description">
            <div class="img-container">
              <img
                style="width: 198px; height: 108px;"
                src="@/assets/checker/m-spec-detail-checker.png"
                alt
              >
              <p class="name">본체</p>
            </div>
            <div class="img-container m-mid-img">
              <img
                style="width: 198px; height: 41px;"
                src="@/assets/checker/m-spec-detail-magnet.png"
                alt
              >
              <p class="name">마그넷</p>
            </div>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">크기 및 무게</p>
          <div>
            <p style="margin-bottom: 6px; font-weight: bold;">본체</p>
            <div class="division-bar"></div>
            <div class="m-spec-description">
              <div>
                <p>크기</p>
                <p style="margin-top: 8px">가로: 7.5cm</p>
                <p>세로: 4cm</p>
                <p>두께: 1.6cm</p>
              </div>
              <div style="vertical-align: top; margin-left: 40px;">
                <p>무게</p>
                <p style="margin-top: 8px">145g</p>
              </div>
            </div>
          </div>
          <div style="margin-top: 30px;">
            <p style="margin-bottom: 6px; font-weight: bold;">마그넷</p>
            <div class="division-bar"></div>
            <div class="m-spec-description">
              <div>
                <p>크기</p>
                <p style="margin-top: 8px">가로: 7.5cm</p>
                <p>세로: 1cm</p>
                <p>두께: 1.6cm</p>
              </div>
              <div style="vertical-align: top; margin-left: 40px;">
                <p>무게</p>
                <p style="margin-top: 8px">145g</p>
              </div>
            </div>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">색상</p>
          <div class="m-spec-description">
            <p>화이트 & 다크 그레이</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">지원 기기</p>
          <div class="m-spec-description">
            <p>iOS, Android</p>
            <p>*해외 안드로이드폰의 경우 호환이 어려울 수 있습니다.</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">연결</p>
          <div class="m-spec-description">
            <p>Wi-Fi</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">요구사항</p>
          <div class="m-spec-description">
            <p>Wi-Fi 네트워크 2.4GHz</p>
          </div>
        </div>
        <div class="m-spec">
          <p class="m-spec-title">충전</p>
          <div class="m-spec-description">
            <p>3시간 이면 배터리 완충</p>
            <p>약 100일 사용</p>
          </div>
        </div>
      </section>
      <checker-faq></checker-faq>
    </div>
  </div>
</template>
<script>
import CheckerFaq from './CheckerFaq'
export default {
  name: 'checker-spec',
  components: { CheckerFaq }
}
</script>

<style scoped>
.checker-spec-hero {
  background: url("../../../assets/checker/checker-spec-hero.png") no-repeat
    center center;
  background-size: cover;
  min-height: 500px;
  display: flex;
  align-items: center;
}

.spec .checker-spec-title {
  font-size: 24px;
  vertical-align: top;
  width: 15%;
  text-align: left;
  font-weight: 400;
}
.checker-spec-hero span {
  font-size: 24px;
  font-weight: bold;
  margin-left: 10%;
  color: #ffffff;
}
.checker-spec-description {
  display: inline-block;
  width: 45%;
  margin-left: 70px;
  text-align: left;
}
.checker-spec-description div {
  display: inline-block;
}
.checker-spec-description img {
  vertical-align: bottom;
}
.checker-spec-description p {
  font-size: 16px;
  font-weight: 400;
  color: #3d4953;
  margin: 0;
}
.checker-mid-img {
  margin-left: 20px;
  margin-right: 20px;
}
.spec {
  display: flex;
  justify-content: center;
  margin-top: 90px;
}
.spec .spec-title {
  vertical-align: top;
  font-size: 24px;
  width: 15%;
}

.m-mid-img {
  margin-top: 20px;
}

.name {
  margin-top: 10px !important;
}

.dimension {
  display: inline-flex;
  justify-content: space-between;
}

.dimension-title {
  vertical-align: top;
}
.dimension-description {
  margin-left: 50px;
  text-align: left;
}
.img-container {
  text-align: center;
}
.m-checker-spec-hero {
  background: url("../../../assets/checker/m-checker-spec-hero.png") no-repeat center center;
  background-size: 100% 100%;
  min-height: 449px;
  text-align: left;
  padding: 41px 0px 0px 26px;
}
.m-checker-spec-hero h1 {
  font-size: 18px;
  font-weight: bold;
  color: #3d4953;
}
.m-checker-spec-hero p {
  margin: 23px 0px 0px 0px;
  font-size: 18px;
  color: #3d4953;
}
.m-specs-detail {
  padding: 0px 26px 90px 26px;
}
.m-spec {
  text-align: left;
  margin-top: 67px;
}
.m-spec .m-spec-title {
  font-size: 18px;
}

.m-spec-description {
  margin-top: 25px;
  font-size: 14px;
  line-height: 1.71;
  letter-spacing: 0;
  color: #3d4953;
}
.m-spec-description div {
  display: inline-block;
}
.m-spec-description p {
  margin: 0;
}

.m-spec-description img {
  vertical-align: bottom;
}

.division-bar {
  width: 100%;
  border: solid 1px #dee2e5;
}
</style>



// WEBPACK FOOTER //
// src/components/products/checker/CheckerSpec.vue